/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SubdivisionsInputs */

const de__field_subdivisions = /** @type {(inputs: _Field_SubdivisionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untergeordneter Kooperationspartner`)
};

/**

* @param {_Field_SubdivisionsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_subdivisions = /** @type {((inputs?: _Field_SubdivisionsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SubdivisionsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_subdivisions(inputs)
});